module.exports = __webpack_public_path__ + "img/bee.928c8fff.svg";